export * from './ToiletIcon'
